import type { SVGProps } from 'react';

export interface FavoritesIconProps extends Omit<SVGProps<SVGSVGElement>, 'xmlns' | 'children'> {}

const FavoritesIcon = ({
  className,
  width = '20',
  height = '20',
  ...rest
}: FavoritesIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    {...rest}
    width={width}
    height={height}
    className={className}
    fill="none"
    aria-hidden={true}
    focusable="false"
  >
    <rect width="20" height="20" rx="10" fill="#D9AA4F" />
    <path
      d="M14.8937 9.20035L12.7024 11.3364L13.2199 14.3534C13.2424 14.4853 13.1883 14.6186 13.0799 14.6974C13.0187 14.7421 12.9459 14.7646 12.8731 14.7646C12.8171 14.7646 12.7608 14.7512 12.7095 14.7241L10 13.2998L7.29087 14.7238C7.17267 14.7864 7.02879 14.7762 6.92044 14.6971C6.81208 14.6183 6.75791 14.4849 6.78042 14.353L7.29791 11.3361L5.10626 9.20035C5.01057 9.10677 4.97574 8.96676 5.01725 8.83977C5.05877 8.71277 5.16888 8.61955 5.3015 8.6002L8.33006 8.16046L9.68444 5.4158C9.803 5.17553 10.197 5.17553 10.3156 5.4158L11.6699 8.16046L14.6985 8.6002C14.8311 8.61955 14.9412 8.71242 14.9827 8.83977C15.0243 8.96711 14.9894 9.10642 14.8937 9.20035Z"
      fill="white"
    />
  </svg>
);

export default FavoritesIcon;
